import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const mainLayoutHeaderLinkSX = {
  display: 'flex',
  color: 'grey.900',
  textDecoration: 'none',
  alignContent: 'center',
  alignItems: 'center',
  ml: 5,
  '&:hover': {
    textDecoration: 'underline',
  },
};

export const mainLayoutHeaderProfileSelectorBoxSX = {
  display: { xs: 'none', md: 'block' },
  mr: 2,
  flexGrow: 1,
};

export const MainLayoutHeaderLeftBox = styled(Box)(({ theme }) => ({
  width: 276,
  height: theme.spacing(6),
  display: 'flex',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    width: 'auto',
  },
}));

export const MainLayoutHeaderDividerBox = styled(Box)({
  flexGrow: 1,
});
